import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close_light",
  "use": "close_light-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close_light\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.45363 8L0 15.4536L0.546369 16L8 8.54637L15.4536 16L16 15.4536L8.54637 8L16 0.546369L15.4536 0L8 7.45363L0.546368 0L0 0.546369L7.45363 8Z\" fill=\"#9E9E9E\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol